import React, { useState } from "react";
import MuiHeader from "../../components/MuiHeader";

import Data from "./Data";
import Collection from "./Collection";

import PropTypes from "prop-types";
import { AppBar, Tabs, Tab, Box, useTheme, Typography } from "@mui/material";

// -------------------- Tab pannel ------------------------
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
};
// --------------------------------------------------------

const AudioAssessmentPage = () => {
  const theme = useTheme();
  // ----------------- Tab Pannel ---------------
  const [tabIndex, setTabIndex] = useState(0);

  const onTabChange = (event, index) => {
    setTabIndex(index);
  };
  const onTabIndexChange = (index) => {
    setTabIndex(index);
  };
  // ---------------------------------------------

  return (
    <>
      <div>
        <MuiHeader header="Audio Assessment" />
        <Box sx={{ bgcolor: "background.paper", width: "100%" }}>
          <AppBar position="static" style={{ background: "#2E3B55" }}>
            <Tabs
              value={tabIndex}
              onChange={onTabChange}
              indicatorColor="primary"
              textColor="inherit"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              <Tab label="Audio Assessment Data" {...a11yProps(0)} />
              <Tab label="Audio Assessment Data Collection" {...a11yProps(1)} />
            </Tabs>
          </AppBar>
          <div
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={tabIndex}
            onChangeIndex={onTabIndexChange}
          >
            <TabPanel value={tabIndex} index={0} dir={theme.direction}>
              <Data />
            </TabPanel>
            <TabPanel value={tabIndex} index={1} dir={theme.direction}>
              <Collection />
            </TabPanel>
          </div>
        </Box>
      </div>
    </>
  );
};
export default AudioAssessmentPage;
